import { useLiveQuery } from 'dexie-react-hooks';
import { useEffect, useState } from 'react';
import { replica } from '@/shared/sync/replica';

/** An object URL for a stored file: undefined while loading, null when not on this device. */
export function useBlobUrl(sha256: string | undefined): string | null | undefined {
  const stored = useLiveQuery(
    async function load() {
      return sha256 ? ((await replica.db.blobs.get(sha256)) ?? null) : null;
    },
    [sha256],
  );
  const [url, setUrl] = useState<string | null | undefined>(undefined);
  useEffect(
    function syncObjectUrl() {
      if (!stored) {
        setUrl(stored);
        return;
      }
      const objectUrl = URL.createObjectURL(stored.blob);
      setUrl(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    },
    [stored],
  );
  return url;
}
